import { render, staticRenderFns } from "./LayoutGuoJiao.vue?vue&type=template&id=68144d59&scoped=true"
import script from "./LayoutGuoJiao.vue?vue&type=script&lang=js"
export * from "./LayoutGuoJiao.vue?vue&type=script&lang=js"
import style0 from "./LayoutGuoJiao.vue?vue&type=style&index=0&id=68144d59&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68144d59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68144d59')) {
      api.createRecord('68144d59', component.options)
    } else {
      api.reload('68144d59', component.options)
    }
    module.hot.accept("./LayoutGuoJiao.vue?vue&type=template&id=68144d59&scoped=true", function () {
      api.rerender('68144d59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/LayoutGuoJiao.vue"
export default component.exports